import binanceLogo from "../../assets/wallets/binance.png"
import bitgetLogo from "../../assets/wallets/bitget.png"
import bybitLogo from "../../assets/wallets/bybit.png"
import imtokenLogo from "../../assets/wallets/imtoken.png"
import okxLogo from "../../assets/wallets/okx.png"
import safepalLogo from "../../assets/wallets/safepal.svg"
import tokenpocketLogo from "../../assets/wallets/tokenpocket.png"
import tronlinkLogo from "../../assets/wallets/tronlink.png"
import trustLogo from "../../assets/wallets/trust.png"
import type { FeaturedWallet } from "../types"

/**
 * Wallets shown in the connect modal.
 * Clicking a row connects TRON immediately when a TRON provider is available;
 * otherwise mobile users are deeplinked into the wallet’s in-app browser.
 * Phantom / My Wallet are intentionally omitted from the modal.
 */
export const featuredWallets: FeaturedWallet[] = [
  {
    id: "tronlink",
    name: "TronLink",
    chain: "tron",
    match: ["tronlink"],
    installUrl: "https://www.tronlink.org/",
    logo: tronlinkLogo,
    tronProvider: "tronlink",
  },
  {
    id: "tokenpocket",
    name: "TokenPocket",
    chain: "tron",
    match: ["tokenpocket"],
    installUrl: "https://www.tokenpocket.pro/en/download/app",
    logo: tokenpocketLogo,
    tronProvider: "tokenpocket",
  },
  {
    id: "okx",
    name: "OKX Wallet",
    chain: "tron",
    match: ["okx"],
    installUrl: "https://www.okx.com/web3",
    logo: okxLogo,
    tronProvider: "okx",
  },
  {
    id: "trust",
    name: "Trust Wallet",
    chain: "tron",
    match: ["trust"],
    installUrl: "https://trustwallet.com/download",
    logo: trustLogo,
    tronProvider: "trust",
  },
  {
    id: "binance",
    name: "Binance Wallet",
    chain: "tron",
    match: ["binance"],
    installUrl: "https://www.binance.com/en/web3wallet",
    logo: binanceLogo,
    tronProvider: "binance",
  },
  {
    id: "safepal",
    name: "SafePal",
    chain: "tron",
    match: ["safepal"],
    installUrl: "https://www.safepal.com/download",
    logo: safepalLogo,
    tronProvider: "safepal",
  },
  {
    id: "imtoken",
    name: "imToken",
    chain: "tron",
    match: ["imtoken"],
    installUrl: "https://token.im/download",
    logo: imtokenLogo,
    tronProvider: "imtoken",
  },
  {
    id: "bitget",
    name: "Bitget",
    chain: "tron",
    match: ["bitget", "bitkeep"],
    installUrl: "https://web3.bitget.com/en/wallet-download",
    logo: bitgetLogo,
    tronProvider: "bitget",
  },
  {
    id: "bybit",
    name: "Bybit",
    chain: "tron",
    match: ["bybit"],
    installUrl: "https://www.bybit.com/web3/",
    logo: bybitLogo,
    tronProvider: "bybit",
  },
]

export function getFeaturedWallet(id: string): FeaturedWallet | undefined {
  return featuredWallets.find((wallet) => wallet.id === id)
}

export const curatedWallets = featuredWallets

export const primaryConnectors: FeaturedWallet[] = []
